export default __webpack_public_path__ + "static/media/g-xl-2.a0f91041.png";